/**
 * Application branding (KD Rise Motor).
 *
 * The deployment used to ship two logos (H2BIS for dev/staging, SLIM for live).
 * Both now resolve to the single KD Rise Motor logo; the two exports are kept so
 * existing importers keep working.
 */
export const BRAND_LOGO = '/logo-kd-rise.png';

/** @deprecated use BRAND_LOGO - kept for existing imports. */
export const SLIM_LOGO_DEV = BRAND_LOGO;

/** @deprecated use BRAND_LOGO - kept for existing imports. */
export const SLIM_LOGO_PROD = BRAND_LOGO;

/** Black/mono logo used as the watermark on printed reports. */
export const BRAND_LOGO_WATERMARK = '/logo-kd-rise.png';

/** Brand name shown in the UI, documents and report footers. */
export const BRAND_NAME = 'KD Rise Motor';

const PROD_ENV_VALUES = new Set(['production', 'prod']);

/**
 * Resolve deployment environment.
 * Build-time VITE_APP_ENV (Docker/CI) takes precedence over runtime window.ENV.
 */
export function getAppEnv() {
  const viteEnv = import.meta.env?.VITE_APP_ENV;
  if (viteEnv) return String(viteEnv).trim().toLowerCase();

  if (typeof window !== 'undefined' && window.ENV?.VITE_APP_ENV) {
    return String(window.ENV.VITE_APP_ENV).trim().toLowerCase();
  }

  if (import.meta.env?.DEV) return 'development';
  return 'production';
}

/** True when the app should use production (live) branding. */
export function isProductionAppEnv() {
  return PROD_ENV_VALUES.has(getAppEnv());
}

/** Public URL path for the brand logo. */
export function getSlimLogoPath() {
  return BRAND_LOGO;
}

const APP_TITLE_SUFFIX = 'Enterprice Resource Planning System';

/** Browser tab / document title. */
export function getAppTitle() {
  return `${BRAND_NAME} - ${APP_TITLE_SUFFIX}`;
}

/** Company name shown on payslips and similar documents. */
export function getCompanyName() {
  return BRAND_NAME;
}
